import React, { FC, useState, useEffect } from 'react';
import './style.scss';

interface Props {
  icon?: string;
  label: string;
  content: string;
  styleDef?: React.CSSProperties;
  labelStyleDef?: React.CSSProperties;
  type?: string;
}

const DefaultLabel: FC<Props> = ({ icon, label, styleDef, labelStyleDef, type, content }) => {
  return (
    <div className={['_label_box_div', type].join(' ')} style={styleDef}>
      <div className="_label" style={labelStyleDef}>
        {label}
      </div>
      <div className="_content">{content}</div>
    </div>
  );
};

export default DefaultLabel;
